import React from "react";
import { useTranslation } from "react-i18next";
import ProfileContent from "../../components/profile-content/profile-content.component";
import SettingsHead from "../../components/settings-head/settings-head.component";
import { CommonService } from "../../services/common/common.service";

export default function ProfilePage(props: any) {
  const [t] = useTranslation();
  const commonService: CommonService = new CommonService();
  commonService.setTitle(t("user management"));

  return (
    <>
      <div className="role-contain">
        <div className="content">
          <SettingsHead title={t('user management')} subTitle={t('organize your account-specific information here')} />
          <ProfileContent />
        </div>
      </div>
    </>
  );
}
